module.exports = __webpack_public_path__ + "static/media/xzs.a1a1a0a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xzs.jpg
// module id = 839
// module chunks = 2